// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react';
import {FlatList, View, RefreshControl, StyleSheet} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {RootStore} from '../../../redux/store';
import {
  GetDeliveries,
  DeleteDelivery,
  setDeliveriesTabSelected,
} from '../deliveriesReducer';
import {useNavigation, useRoute} from '@react-navigation/native';
import Center from '../../../components/Center';
import {showDeleteUnitPrompt} from '../../../utils/showDeletePrompt';
import DeliveryItem from '../components/DeliveryItem';
import LoadingSpinner from '../../../components/LoadingSpinner';
import NavbarWithAction from '../../../components/NavbarWithAction';
import Container from '../../../components/Container';
import {E_NAVIGATION_DESTINATIONS} from '../../../@types';
import {getDeliveryPermissions} from '../permissions';

const Deliveries: React.FC<{
  embedded?: boolean;
  fetchOnMount?: boolean;
}> = ({embedded, fetchOnMount}) => {
  const navigation = useNavigation();
  const route = useRoute<any>();
  const dispatch = useDispatch();
  const {deliveries, loading} = useSelector(
    (state: RootStore) => state.deliveries,
  );
  const currentUnitLink = useSelector((state: RootStore) =>
    state.units.unitLinks?.find(link => link.isDefault === true),
  );
  const [refreshing, setRefreshing] = useState(false);
  const isEmbedded = embedded ?? !!route.params?.embedded;
  const shouldFetchOnMount =
    fetchOnMount ?? route.params?.fetchOnMount !== false;
  const deliveryPermissions = getDeliveryPermissions(
    currentUnitLink?.deliveryPermission,
  );

  useEffect(() => {
    if (shouldFetchOnMount) {
      dispatch(GetDeliveries());
    }
  }, [dispatch, shouldFetchOnMount]);

  React.useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      dispatch(setDeliveriesTabSelected(true));
    });

    return unsubscribe;
  }, [dispatch, navigation]);

  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    dispatch(GetDeliveries());
    setRefreshing(false);
  }, [dispatch]);

  const content = loading ? (
    <LoadingSpinner />
  ) : (
    <FlatList
      showsVerticalScrollIndicator={false}
      refreshControl={
        <RefreshControl onRefresh={onRefresh} refreshing={refreshing} />
      }
      data={deliveries}
      keyExtractor={(item, _) => item.id}
      style={styles.flatList}
      ListFooterComponent={<View style={styles.footer} />}
      ListEmptyComponent={
        <Center style={styles.center}>
          You have no deliveries at the moment
        </Center>
      }
      renderItem={({item}) => (
        <DeliveryItem
          delivery={item}
          onSelectDelete={() =>
            showDeleteUnitPrompt('delivery', () => {
              dispatch(DeleteDelivery(item.id));
            })
          }
          itemClickHandler={() =>
            navigation.navigate(E_NAVIGATION_DESTINATIONS.DELIVERY_DETAILS, {
              delivery: item,
            })
          }
          onSelectEdit={() =>
            navigation.navigate(E_NAVIGATION_DESTINATIONS.ADD_DELIVERY, {
              delivery: item,
            })
          }
        />
      )}
    />
  );

  if (isEmbedded) {
    return content;
  }

  return (
    <Container>
      <NavbarWithAction
        hasSignOut={false}
        navigation={navigation}
        hasBackArrow
        title="deliveries"
        showCurrentUnit
        hasAdd={deliveryPermissions.canAdd}
        onClickAdd={() => navigation.navigate('Add delivery', {delivery: null})}
        showUnitPicture={false}
        onClickFilter={() => null}
        hasFilter={false}
        hasAccessCard
        onClickAccessCard={() =>
          navigation.navigate(E_NAVIGATION_DESTINATIONS.ID_CARD)
        }
        fullScreen
      />
      {content}
    </Container>
  );
};

const styles = StyleSheet.create({
  flatList: {
    marginVertical: 12,
    marginHorizontal: 8,
  },
  footer: {
    height: 32,
  },
  center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default Deliveries;
